export abstract class Clearable {
  abstract clear(): void
  abstract isEmpty(): boolean
}
